import { render, staticRenderFns } from "./ContractModalSkeleton.vue?vue&type=template&id=f2efd972&scoped=true&"
import script from "./ContractModalSkeleton.vue?vue&type=script&lang=js&"
export * from "./ContractModalSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ContractModalSkeleton.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ContractModalSkeleton.vue?vue&type=style&index=1&id=f2efd972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2efd972",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog})
